// -- Lifecycle hooks
class MomaxNewsletterMedia extends HTMLElement {
  connectedCallback() {
    this.viewport = window.matchMedia('(max-width: 740px)');
    this.updateMedia = () => {
      const slot = this.querySelector('[data-news-media]');
      const device = this.viewport.matches ? 'mobile' : 'desktop';
      const template = this.querySelector(`[data-news-device="${device}"]`);
      if (!slot || !template) return;
      slot.querySelector('video')?.pause();
      slot.replaceChildren(template.content.cloneNode(true));
    };
    this.viewport.addEventListener('change', this.updateMedia);
    this.updateMedia();
  }

  disconnectedCallback() {
    this.viewport.removeEventListener('change', this.updateMedia);
    this.querySelector('video')?.pause();
  }
}

if (!customElements.get('momax-newsletter-media')) {
  customElements.define('momax-newsletter-media', MomaxNewsletterMedia);
}
